import './App.scss';

import { AppRoutes } from './routes';
import CompanyAPI from './pages/company/CompanyAPI';
import { NotificationProvider } from './commons/firebase/NotificationProvider';
import NewAppMigrationModal from './commons/NewAppMigrationModal';
import { syncFcmTokenOnAppStart } from './commons/firebase/message';
import { useEffect } from 'react';
import { useRuntime } from './commons/runtime/RuntimeContext';

const companyAPI = new CompanyAPI();

function App() {
  const { isFlutterWebView } = useRuntime();

  useEffect(() => {
    if (isFlutterWebView) return;
    const companyId = companyAPI.getCompanyManagment()?.id;

    if (companyId) {
      syncFcmTokenOnAppStart({
        vapidKey: "BFlf90Q2dmeKJPXmCAZ1Je0yHG5qN5XejTIYkNkwk2B19azTZJ7Ud3_2fC8-QS-VOnEsZKhBpaMj7Y1lToBoshc",
        companyId,
      });
    }

  }, [isFlutterWebView]);


  return (
    <NotificationProvider>
      <AppRoutes />
      <NewAppMigrationModal />
    </NotificationProvider>
  );
}

export default App;
